if (!customElements.get('theme-tab')) {
    customElements.define('theme-tab', class ThemeTab extends HTMLElement {
      constructor() {
        super();
        console.log('dsfsfsfsfsdfds');
      }
  
      open(button, tab) {
        const _target = button.closest('li');
       console.log(_target);
  
        if (_target.classList.contains('active')) return;
  
        const _active = this.querySelector(`li.active`);
        const _activeTab = this.querySelector(`.tab__content-item.active`);
        const _targetTab = this.querySelector(`[data-tab-id="${tab}"]`);
  
        _active.classList.remove('active');
        _activeTab.classList.remove('active');
        _target.classList.add('active');
        _targetTab.classList.add('active');
      }
    });
  }